$stylePerso = '';

$(function () {
    $('[data-toggle="tooltip"]').tooltip();
    $stylePerso = $('#stylePerso').html();

    //VERIFICANDO CACHE
    let AccessibilityColor = localStorage.getItem("AccessibilityColor");
    saveAccessibilityColor(parseInt(AccessibilityColor));
});

//=====================================
//  SHORTCUTS
//=====================================
/*** GO TO CONTENT ***/
shortcut.add("ALT+1",function(){
    goToContent();
});

/*** APPLY HIGH CONTRAST EFECT ***/
shortcut.add("ALT+2",function(){
    saveAccessibilityColor(2);
});

/*** APPLY DEFAULT COLOR ***/
shortcut.add("ALT+4",function(){
    saveAccessibilityColor(1);
});

/*** OPEN VLIBRAS ***/
shortcut.add("ALT+5",function(){
    openOrCloseVlibras(true);
});

/*** INCREASE FONT ***/
shortcut.add("ALT+6",function(){
    $('#increaseFont').trigger('click');
});

/*** DECREASE FONT ***/
shortcut.add("ALT+7",function(){
    $('#decreaseFont').trigger('click');
});

/*** NORMAL FONT ***/
shortcut.add("ALT+8",function(){
    $('#normalFont').trigger('click');
});

//=====================================
//  EVENTS
//=====================================
/*** GO TO CONTENT ***/
$('#goToContent').click(function (){
    goToContent();
});

/*** OPEN VLIBRAS ***/
$('#openVlibras').click(function (){
    openOrCloseVlibras(true);
});

/*** CLOSE VLIBRAS ***/
$('#closeVlibras').click(function (){
    openOrCloseVlibras(false);
});

/*** APPLY HIGH CONTRAST EFECT ***/
$('#highContrast').click(function (){
    saveAccessibilityColor(2);
});

/*** APPLY DEFAULT COLOR ***/
$('#defaultColor').click(function (){
    saveAccessibilityColor(1);
});

//=====================================
//  FUNCTIONS
//=====================================
let last_css_add = '';

/*** GO TO CONTENT ***/
function goToContent(){
    document.getElementById("conteudo").scrollIntoView();
    $('#conteudo').focus();
}

/*** OPEN OR CLOSE VLIBRAS ***/
function openOrCloseVlibras(action){
    action ? $('div').filter('[vw-access-button]').trigger('click') : $('img').filter('.vpw-settings-btn-close').trigger('click');
}

/*** SELECT CSS ***/
function setActiveStyleSheet(css_selected) {
    var links_css = document.querySelectorAll("link");
    var css_selecionado = links_css[links_css.length-2].href;
    var default_css = "styles.css";

    if(last_css_add === ''){
        last_css_add = default_css;
    }

    var css_to = '';
    var css_from = '';
    var success = 0;

    if(last_css_add != css_selected){
        css_to = last_css_add;
        css_from = css_selected === 'default' ? default_css : css_selected;
        last_css_add = css_selected === 'default' ? default_css : css_selected;

        if(css_from == 'styles.css'){
            $('body').removeClass('contraste-ativo');
        }else{
            $('body').addClass('contraste-ativo');
        }

        if(css_from == 'contrast_adm.css'){
            if($('#logo-login').length > 0){
                var logo_url = $('#logo-login').attr('src-contrast');
                $('#logo-login').attr('src', logo_url);
            }
        }else{
            if($('#logo-login').length > 0){
                var logo_url = $('#logo-login').attr('src-padrao');
                $('#logo-login').attr('src', logo_url);
            }
        }
    }
}

function saveAccessibilityColor(option){
    //ALTER COLOR
    alterColorForce(option);
    switch (option){
        case 1:
            setActiveStyleSheet('default');
            break;
        case 2:
            setActiveStyleSheet('contrast_adm.css');
            break;
        default:
            setActiveStyleSheet('default');
            break;
    }

    //SAVE IN CACHE
    localStorage.setItem("AccessibilityColor", option);
}

function alterColorForce(type = 0){
    $('.alter-color').each(function() {
        if(type == 2){
            $('.alter-color').removeAttr('style');
            $('#stylePerso').empty();
        }else{
            var novoValor = $(this).attr('new-style');
            var novoNomeAtributo = 'style';
            $(this).attr(novoNomeAtributo, novoValor);
            $('#stylePerso').html($stylePerso);
        }
    });
}

/*** CHANGE FONT SIZE ***/
fontSiteChange = 0;
elementosTextos = ['a', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'span', 'label', 'div', 'p', 'ins', 'button', 'input'];

$('#increaseFont').click(function(){
    fontSiteChange += 1;

    for(var e = 0; e < elementosTextos.length; e++) {
        var elementos = $(elementosTextos[e]);

        for (var i = 0; i < elementos.length; i++) {
            var fonte = window.getComputedStyle(elementos[i]).getPropertyValue('font-size');
            var tamanhoAtual = parseFloat(fonte);

            var novoTamanho = tamanhoAtual + 1;

            elementos[i].style.fontSize = novoTamanho + 'px';
        }
    }
});

$('#decreaseFont').click(function(){
    fontSiteChange -= 1;

    for(var e = 0; e < elementosTextos.length; e++) {
        var elementos = $(elementosTextos[e]);

        for (var i = 0; i < elementos.length; i++) {
            var fonte = window.getComputedStyle(elementos[i]).getPropertyValue('font-size');
            var tamanhoAtual = parseFloat(fonte);

            var novoTamanho = tamanhoAtual - 1;

            elementos[i].style.fontSize = novoTamanho + 'px';
        }
    }
});

$('#normalFont').click(function(){
    for(var e = 0; e < elementosTextos.length; e++) {
        var elementos = $(elementosTextos[e]);

        for (var i = 0; i < elementos.length; i++) {
            var fonte = window.getComputedStyle(elementos[i]).getPropertyValue('font-size');
            var tamanhoAtual = parseFloat(fonte);

            var novoTamanho = tamanhoAtual - fontSiteChange;

            elementos[i].style.fontSize = novoTamanho + 'px';
        }
    }

    fontSiteChange = 0;
});

$('#btMenuAcess').click(function (){
    if($('#navbarMenuAcessCollapse').hasClass('show')){
        $('#navbarMenuAcessCollapse').removeClass('show');
    }else{
        $('#navbarMenuAcessCollapse').addClass('show');
    }
});
